(function(){
  var PAGE=8, shown=PAGE, all=[], state={rating:0, q:'', sort:'featured'}, SUMMARY=null;
  var $=function(s){return document.querySelector(s)};
  var CHECK='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1l2.6 2.2 3.4-.4 1 3.3 3 1.7-1 3.2 1 3.2-3 1.7-1 3.3-3.4-.4L12 23l-2.6-2.2-3.4.4-1-3.3-3-1.7 1-3.2-1-3.2 3-1.7 1-3.3 3.4.4z"/><path d="M8 12l3 3 5-6" stroke="#fff" stroke-width="2.2" fill="none"/></svg>';
  var UP='<svg viewBox="0 0 24 24"><path d="M7 11v9H4v-9z"/><path d="M7 11l4-8c1.5 0 2.5 1 2.5 2.5V9h5a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 17.3 20H7"/></svg>';
  function esc(t){return String(t==null?'':t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function stars(n){var s='';for(var i=1;i<=5;i++)s+='<span class="'+(i<=n?'':'off')+'">★</span>';return s}
  function initials(n){return esc(String(n||'?').split(/\s+/).map(function(w){return w.charAt(0)}).join('').slice(0,2).toUpperCase())}
  function ago(d){
    if(!d) return '';
    var t=new Date(d+'T12:00:00'), days=Math.floor((Date.now()-t)/864e5);
    if(isNaN(days)) return '';
    if(days<1) return 'Today'; if(days<7) return days+' day'+(days>1?'s':'')+' ago';
    if(days<30){var w=Math.floor(days/7);return w+' week'+(w>1?'s':'')+' ago'}
    if(days<365){var m=Math.floor(days/30);return m+' month'+(m>1?'s':'')+' ago'}
    var y=Math.floor(days/365);return y+' year'+(y>1?'s':'')+' ago';
  }
  function votes(){try{return JSON.parse(localStorage.getItem('mv_votes'))||{}}catch(e){return {}}}
  function saveVotes(v){try{localStorage.setItem('mv_votes',JSON.stringify(v))}catch(e){}}

  function filtered(){
    var q=state.q.toLowerCase();
    var l=all.filter(function(r){
      return (!state.rating||r.rating===state.rating) && (!q||(r.body+' '+(r.title||'')+' '+r.name).toLowerCase().indexOf(q)>-1);
    });
    var by={
      featured:function(a,b){return (b.featured?1:0)-(a.featured?1:0)||(b.date||'').localeCompare(a.date||'')},
      recent:function(a,b){return (b.date||'').localeCompare(a.date||'')},
      high:function(a,b){return b.rating-a.rating},
      low:function(a,b){return a.rating-b.rating},
      helpful:function(a,b){return (b.helpful||0)-(a.helpful||0)}
    };
    return l.sort(by[state.sort]);
  }

  function row(r){
    var v=votes()[r.id], long=r.body.length>320;
    return '<li class="rv" data-id="'+esc(r.id)+'">'+
      '<div class="who">'+
        '<div class="who-top"><span class="av">'+initials(r.name)+'</span><div><b>'+esc(r.name)+'</b>'+(r.verified?'<span class="ver">'+CHECK+'Verified purchase</span>':'')+'</div></div>'+
        '<div class="prod"><img src="'+(/bottle/i.test(r.product||'')?'//monavie.shop/cdn/shop/t/22/assets/mv-hero-bottle.png?v=174292033709511729901790702392':'//monavie.shop/cdn/shop/t/22/assets/mv-monavie-duo.png?v=145963146409527546951790702392')+'" alt=""><span>Reviewing<br><b>'+esc(r.product||'MonaVie Active')+'</b></span></div>'+
        (r.rating>=4?'<span class="recd"><svg viewBox="0 0 24 24"><path d="M5 12l5 5L20 7"/></svg>I recommend this product</span>':'')+
      '</div>'+
      '<div>'+
        '<div class="body-top"><span class="stars" aria-label="'+r.rating+' out of 5 stars">'+stars(r.rating)+'</span><span class="date">'+ago(r.date)+'</span></div>'+
        (r.title?'<h3>'+esc(r.title)+'</h3>':'')+
        '<p'+(long?' class="clamp"':'')+'>'+esc(r.body)+'</p>'+
        (long?'<button type="button" class="more-link" data-expand>Read more</button>':'')+
        (r.photos?'<div class="photos">'+r.photos.map(function(u){return '<button type="button" data-photo="'+esc(u)+'" aria-label="View photo from '+esc(r.name)+'"><img src="'+esc(u)+'" alt="" loading="lazy"></button>'}).join('')+'</div>':'')+
        '<div class="rv-foot">'+
          (r.source==='amazon'?'<span class="src">Review from Amazon</span>':'<span></span>')+
          '<div class="help">Was this helpful?<button type="button" data-vote="up" aria-pressed="'+(v==='up')+'">'+UP+'<span>'+((r.helpful||0)+(v==='up'?1:0))+'</span></button></div>'+
        '</div>'+
      '</div></li>';
  }

  function renderSummary(){
    /* Headline rating matches the PDP (SUMMARY in reviews.json). Swap for real numbers before launch. */
    if(!SUMMARY){ $('#summary').hidden=true; return; }
    var avg=SUMMARY.rating, n=all.length||1;   /* star bars are shares of the reviews shown here */
    $('#avg').textContent=avg.toFixed(1)+(SUMMARY.count?'':'/5');
    $('#avg-stars').innerHTML=stars(Math.round(avg));
    $('#based').textContent=SUMMARY.count?'from '+SUMMARY.count.toLocaleString('en-US')+' reviews':'';
    $('#dist').innerHTML=[5,4,3,2,1].map(function(k){
      var c=all.filter(function(r){return r.rating===k}).length;
      return '<button type="button" data-r="'+k+'" aria-pressed="'+(state.rating===k)+'"><span>'+k+' star</span><span class="track"><i style="width:'+(c/n*100)+'%"></i></span><span>'+Math.round(c/n*100)+'%</span></button>';
    }).join('');
    $('#summary').hidden=false;
  }
  function renderChips(){
    var opts=[0,5,4,3,2,1].filter(function(k){return !k||all.some(function(r){return r.rating===k})});
    $('#chips').innerHTML=opts.length>2?opts.map(function(k){return '<button type="button" data-r="'+k+'" aria-pressed="'+(state.rating===k)+'">'+(k?k+' stars':'All reviews')+'</button>'}).join(''):'';
  }
  function render(){
    var l=filtered();
    $('#count').textContent=(state.rating||state.q)?(l.length+' matching review'+(l.length===1?'':'s')):'What customers are saying';
    $('#list').innerHTML=l.length?l.slice(0,shown).map(row).join(''):'<li class="empty">No reviews match your search.</li>';
    $('#load').hidden=l.length<=shown;
    renderSummary(); renderChips();
  }

  document.addEventListener('click',function(e){
    var r=e.target.closest('[data-r]');
    if(r){ var k=+r.dataset.r; state.rating=state.rating===k?0:k; shown=PAGE; render(); return; }
    if(e.target.closest('#more')){ shown+=PAGE; render(); return; }
    var x=e.target.closest('[data-expand]');
    if(x){ var p=x.previousElementSibling; var open=p.classList.toggle('clamp'); x.textContent=open?'Read more':'Show less'; return; }
    var ph=e.target.closest('[data-photo]');
    if(ph){ var lb=$('#lightbox'); lb.querySelector('img').src=ph.dataset.photo; lb.hidden=false; lb.querySelector('button').focus(); return; }
    if(e.target.closest('[data-lb-close]')){ $('#lightbox').hidden=true; return; }
    var vb=e.target.closest('[data-vote]');
    if(vb){ var id=vb.closest('.rv').dataset.id, v=votes(); if(v[id]) delete v[id]; else v[id]='up'; saveVotes(v); render(); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') $('#lightbox').hidden=true; });
  $('#sort').addEventListener('change',function(){state.sort=this.value; shown=PAGE; render();});
  $('#q').addEventListener('input',function(){state.q=this.value.trim(); shown=PAGE; render();});

  /* Headline rating and count come from Theme settings, MonaVie, the same setting the PDP rating line and sticky bar use */
  var DATA=(function(){try{return JSON.parse(document.getElementById('mv-data').textContent)||{}}catch(e){return {}}})();
  function photoUrl(u){ return /^(https?:)?\/\//.test(u) ? u : (window.MV && window.MV.assets || '') + u; }
  fetch(window.MV && window.MV.reviewsUrl).then(function(r){return r.json()}).then(function(d){
    all=(d.reviews||[]).filter(function(r){return !r.hidden}).map(function(r){ if(r.photos) r.photos=r.photos.map(photoUrl); return r; });
    SUMMARY=d.summary||null;
    if(DATA.social && DATA.social.rating) SUMMARY={rating:parseFloat(DATA.social.rating), count:Number(DATA.social.reviews)||0};
    render();
  }).catch(function(){ $('#list').innerHTML='<li class="empty">Reviews could not be loaded.</li>'; });
})();
